<template>
  <div class="pagina ativa" id="paginaMinhasVendas">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><ClipboardList :size="20" /> Minhas Vendas</div>
    <div style="background:white;padding:15px 20px;border-radius:10px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;display:flex;gap:15px;flex-wrap:wrap;align-items:flex-end;">
      <div v-if="ehAdmin"><label>Vendedor</label><select v-model="filtros.vendedor" style="width:180px;"><option value="">Todos</option><option v-for="v in vendedoresUnicos" :key="v" :value="v">{{ v }}</option></select></div>
      <div><label>Cliente</label><input type="text" v-model="filtros.cliente" style="width:180px;" /></div>
      <div><label>Contrato</label><input type="text" v-model="filtros.contrato" style="width:140px;" /></div>
      <div><label>Grupo</label><input type="text" v-model="filtros.grupo" style="width:130px;" /></div>
      <div><label>Cota</label><input type="text" v-model="filtros.cota" style="width:130px;" /></div>
      <div>
        <label>BEM</label>
        <select v-model="filtros.bem" style="width:160px;">
          <option value="">Todos</option><option>AUTOMOVEL</option><option>SERVICO E MOTO</option><option>PESADOS</option><option>IMOVEIS</option><option>IMOVEL ESTENDIDO</option>
        </select>
      </div>
      <div><label>Status</label><select v-model="filtros.status" style="width:150px;"><option value="">Todos</option><option>Ativa</option><option>Contemplada</option><option>Transferida</option><option>Cancelada</option><option>Estornada</option></select></div>
      <div><label>Data De</label><input type="date" v-model="filtros.dataInicio" style="width:155px;" /></div>
      <div><label>Ate</label><input type="date" v-model="filtros.dataFim" style="width:155px;" /></div>
      <div>
        <label>Mes/Ano</label>
        <select v-model="filtros.mes" style="width:130px;">
          <option value="">Todos</option>
          <option value="01">Jan</option><option value="02">Fev</option><option value="03">Mar</option><option value="04">Abr</option>
          <option value="05">Mai</option><option value="06">Jun</option><option value="07">Jul</option><option value="08">Ago</option>
          <option value="09">Set</option><option value="10">Out</option><option value="11">Nov</option><option value="12">Dez</option>
        </select>
        <select v-model="filtros.ano" style="width:100px;"><option value="">Todos</option><option value="2025">2025</option><option value="2026">2026</option><option value="2027">2027</option></select>
      </div>
      <div><button @click="limparFiltros" style="margin-top:0;padding:10px 18px;font-size:13px;background:#888;">Limpar</button></div>
    </div>
    <div class="grid-cards" style="margin-bottom:20px;">
      <div class="card"><div class="card-label">Total de Vendas</div><div class="card-valor">{{ resumo.total }}</div></div>
      <div class="card"><div class="card-label">Valor Total</div><div class="card-valor">{{ fmtBRL(resumo.valor) }}</div></div>
      <div class="card"><div class="card-label">Ticket Medio</div><div class="card-valor">{{ fmtBRL(resumo.ticket) }}</div></div>
    </div>
    <div style="overflow-x:auto;">
      <table class="tabela-dash">
        <thead><tr><th>Data</th><th v-if="ehAdmin">Vendedor</th><th>Cliente</th><th>Contrato</th><th>Grupo</th><th>Cota</th><th>BEM</th><th>Tabela</th><th>Valor</th><th>Venc.</th><th>Lance</th><th>Status</th><th>Obs</th><th>Acoes</th></tr></thead>
        <tbody>
          <tr v-if="carregando"><td :colspan="ehAdmin ? 14 : 13" style="padding:20px;text-align:center;color:#888;">Carregando...</td></tr>
          <tr v-else-if="vendasFiltradas.length === 0"><td :colspan="ehAdmin ? 14 : 13" style="padding:20px;text-align:center;color:#888;">Nenhuma venda.</td></tr>
          <template v-for="v in vendasFiltradas" :key="v.linha">
            <tr>
              <td style="padding:8px;">{{ formatarData(v.dataAlocacao || v.dataVenda) }}</td>
              <td v-if="ehAdmin" style="padding:8px;">{{ v.vendedor }}</td>
              <td style="padding:8px;font-weight:bold;">
                {{ v.cliente }}
                <span v-if="v.isFilha" style="font-size:10px;background:#e0f2fe;color:#0369a1;padding:2px 5px;border-radius:5px;">Transferida</span>
              </td>
              <td style="padding:8px;">{{ v.contrato }}</td>
              <td style="padding:8px;">{{ v.grupo }}</td>
              <td style="padding:8px;color:#4a5c2f;font-weight:bold;">{{ v.cota }}</td>
              <td style="padding:8px;">{{ v.bem }}</td>
              <td style="padding:8px;font-size:12px;">{{ v.tabela }}</td>
              <td style="padding:8px;font-weight:bold;">{{ fmtBRL(v.valor) }}</td>
              <td style="padding:8px;">Dia {{ v.dataVencimento }}</td>
              <td style="padding:8px;">{{ v.lance || '--' }}</td>
              <td style="padding:8px;">
                <span :style="{ background: corStatus(v.status), color: 'white', padding: '2px 8px', borderRadius: '10px', fontSize: '11px' }">{{ v.status }}</span>
                <span v-if="v.status === 'Transferida' && v.novoTitular" style="font-size:10px;background:#f0e8d0;color:#a07000;padding:1px 5px;border-radius:8px;margin-left:4px;">p/ {{ v.novoTitular }}</span>
              </td>
              <td style="padding:8px;text-align:center;">
                <button v-if="v.observacao" @click="toggleObs(v.linha)" :title="v.observacao" style="display:inline-flex;align-items:center;justify-content:center;padding:4px 7px;background:#3498db;margin-top:0;border:none;color:white;border-radius:4px;cursor:pointer;"><MessageCircle :size="13" /></button>
                <span v-else style="color:#ddd;font-size:12px;">—</span>
              </td>
              <td style="padding:8px;white-space:nowrap;">
                <button @click="abrirModalEditar(v)" style="display:inline-flex;align-items:center;justify-content:center;padding:4px 8px;margin-right:4px;margin-top:0;"><Pencil :size="13" /></button>
                <button v-if="ehAdmin" @click="excluir(v.linha, v.cliente)" style="display:inline-flex;align-items:center;justify-content:center;padding:4px 8px;background:#c0392b;margin-top:0;"><Trash2 :size="13" /></button>
              </td>
            </tr>
            <tr v-if="v.observacao && obsAbertas.includes(v.linha)">
              <td :colspan="ehAdmin ? 14 : 13" style="padding:8px 16px;background:#fffde7;border-left:4px solid #f39c12;font-size:13px;color:#555;"><span style="display:inline-flex;align-items:center;gap:5px;"><MessageCircle :size="13" /> <strong>Obs:</strong></span> {{ v.observacao }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>Editar Venda</h3>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:15px;">
          <div><label>VENDEDOR</label><input type="text" v-model="edicao.vendedor" readonly style="background:#f5f5f5;" /></div>
          <div><label>DATA VENDA</label><input type="date" v-model="edicao.dataVenda" /></div>
          <div><label>CLIENTE</label><input type="text" v-model="edicao.nomeCliente" /></div>
          <div><label>CPF</label><input type="text" v-model="edicao.cpf" @input="mascaraCpfCnpjEdicao" maxlength="18" /></div>
          <div><label>CONTRATO *</label><input type="text" v-model="edicao.numeroContrato" /></div>
          <div><label>GRUPO *</label><input type="text" v-model="edicao.numeroGrupo" /></div>
          <div><label>COTA</label><input type="text" v-model="edicao.numeroCota" /></div>
          <div><label>VALOR</label><input type="text" v-model="edicao.valor" @input="mascaraValorEdicao" /></div>
          <div>
            <label>BEM *</label>
            <select v-model="edicao.bem">
              <option value="">Selecione...</option><option>AUTOMOVEL</option><option>SERVICO E MOTO</option><option>PESADOS</option><option>IMOVEIS</option><option>IMOVEL ESTENDIDO</option>
            </select>
          </div>
          <div>
            <label>TABELA VENDA *</label>
            <select v-model="edicao.tabelaVenda">
              <option value="">Selecione...</option>
              <option v-for="t in tabelasFiltradasEdicao" :key="t.linha" :value="t.tabela">{{ t.tabela }}</option>
            </select>
          </div>
          <div><label>DATA ALOCACAO</label><input type="date" v-model="edicao.dataAlocacao" /></div>
          <div>
            <label>VENCIMENTO</label>
            <select v-model="edicao.dataVencimento">
              <option value="">Sel...</option><option value="10">Dia 10</option><option value="15">Dia 15</option><option value="20">Dia 20</option><option value="25">Dia 25</option>
            </select>
          </div>
          <div>
            <label>LANCE</label>
            <select v-model="edicao.lance">
              <option value="">Sel...</option><option value="Lance Livre">Lance Livre</option><option value="25">25%</option><option value="50">50%</option>
            </select>
          </div>
          <div><label>VALOR LIQUIDO DO CREDITO</label><input type="text" :value="valorLiquidoEdicao" readonly style="background:#eef4e6;font-weight:bold;color:#2e3a18;" /></div>
          <div>
            <label>STATUS</label>
            <select v-model="edicao.status">
              <option>Ativa</option><option>Contemplada</option><option>Transferida</option><option>Cancelada</option><option>Estornada</option>
            </select>
          </div>
          <div>
            <label>PARTICIPANTE</label>
            <select v-model="edicao.numeroParticipante">
              <option value="">Sel...</option><option value="5000">5.000</option><option value="900">900</option><option value="600">600</option>
            </select>
          </div>
          <div style="grid-column:1/-1"><label>OBSERVACAO</label><textarea v-model="edicao.observacao" placeholder="Anotacoes sobre a venda (opcional)..." style="width:100%;padding:10px;margin:4px 0 10px;border:1px solid #ccc;border-radius:5px;font-size:14px;height:60px;resize:vertical;"></textarea></div>
        </div>
        <div v-if="edicao.status === 'Transferida'" style="margin-top:15px;background:#fff8e1;border:1px solid #ffe082;border-radius:8px;padding:15px;">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            <div>
              <label>PARCELAS VALIDAS ATE</label>
              <select v-model="edicao.parcelasTransferencia">
                <option value="">Todas</option>
                <option v-for="n in 12" :key="n" :value="String(n)">{{ n }}</option>
              </select>
            </div>
            <div><label>NOVO TITULAR</label><input type="text" v-model="edicao.novoTitular" placeholder="Novo dono" /></div>
          </div>
          <div><label>STATUS COTA TRANSFERIDA</label><select v-model="edicao.statusCotaTransf"><option>Ativa</option><option>Contemplada</option><option>Cancelada</option></select></div>
        </div>
        <div class="status" :class="statusEdicaoClasse">{{ statusEdicaoMsg }}</div>
        <div class="app-drawer-acoes">
          <button @click="modalAberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarEdicao">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete, getSession } from '../api'
import { ClipboardList, MessageCircle, Pencil, Trash2 } from 'lucide-vue-next'

function valorParaNumero(v) {
  return parseFloat((v || '').toString().replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) || 0
}

export default {
  name: 'PaginaMinhasVendas',
  components: { ClipboardList, MessageCircle, Pencil, Trash2 },
  data() {
    return {
      vendas: [],
      tabelas: [],
      carregando: true,
      obsAbertas: [],
      filtros: { vendedor: '', cliente: '', contrato: '', grupo: '', cota: '', bem: '', status: '', dataInicio: '', dataFim: '', mes: '', ano: '' },
      modalAberto: false,
      edicao: {},
      statusEdicaoMsg: '',
      statusEdicaoClasse: ''
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    vendedoresUnicos() {
      const s = new Set(this.vendas.map(v => v.vendedor).filter(Boolean))
      return Array.from(s).sort()
    },
    tabelasFiltradasEdicao() {
      if (!this.edicao.bem) return []
      return this.tabelas.filter(t => t.bem === this.edicao.bem)
    },
    valorLiquidoEdicao() {
      const valor = valorParaNumero(this.edicao.valor)
      const lance = this.edicao.lance
      const pct = (lance === '25' || lance === '50') ? parseFloat(lance) : null
      if (valor > 0 && pct !== null) {
        const liquido = valor - (valor * pct / 100)
        return 'R$ ' + liquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' (' + pct.toFixed(1) + '% de lance)'
      } else if (valor > 0 && lance === 'Lance Livre') {
        return 'A definir (Lance Livre)'
      }
      return ''
    },
    vendasFiltradas() {
      let d = this.vendas.slice()
      if (!this.ehAdmin) {
        const nome = getSession().nome
        d = d.filter(v => v.vendedor === nome)
      } else if (this.filtros.vendedor) {
        d = d.filter(v => v.vendedor === this.filtros.vendedor)
      }
      if (this.filtros.cliente) d = d.filter(v => (v.cliente || '').toLowerCase().indexOf(this.filtros.cliente.toLowerCase()) > -1)
      if (this.filtros.contrato) d = d.filter(v => (v.contrato || '').toLowerCase().indexOf(this.filtros.contrato.toLowerCase()) > -1)
      if (this.filtros.grupo) d = d.filter(v => (v.grupo || '').toLowerCase().indexOf(this.filtros.grupo.toLowerCase()) > -1)
      if (this.filtros.cota) d = d.filter(v => (v.cota || '').toLowerCase().indexOf(this.filtros.cota.toLowerCase()) > -1)
      if (this.filtros.bem) d = d.filter(v => v.bem === this.filtros.bem)
      if (this.filtros.status) d = d.filter(v => v.status === this.filtros.status)
      if (this.filtros.dataInicio) d = d.filter(v => (v.dataVenda || '') >= this.filtros.dataInicio)
      if (this.filtros.dataFim) d = d.filter(v => (v.dataVenda || '') <= this.filtros.dataFim)
      if (this.filtros.mes) d = d.filter(v => (v.dataVenda || '').substring(5, 7) === this.filtros.mes)
      if (this.filtros.ano) d = d.filter(v => (v.dataVenda || '').substring(0, 4) === this.filtros.ano)
      d.sort((a, b) => (b.dataAlocacao || b.dataVenda || '').localeCompare(a.dataAlocacao || a.dataVenda || ''))
      return d
    },
    resumo() {
      const d = this.vendasFiltradas.filter(v => !v.isFilha)
      const total = d.length
      const valor = d.reduce((s, v) => s + (parseFloat(v.valor) || 0), 0)
      return { total, valor, ticket: total ? valor / total : 0 }
    }
  },
  created() {
    this.carregar()
    this.carregarTabelas()
  },
  methods: {
    fmtBRL(v) {
      return 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    corStatus(status) {
      if (status === 'Cancelada') return '#c0392b'
      if (status === 'Contemplada') return '#27ae60'
      if (status === 'Transferida') return '#f39c12'
      if (status === 'Estornada') return '#8e44ad'
      return '#4a5c2f'
    },
    formatarData(iso) {
      if (!iso) return '--'
      const p = iso.toString().substring(0, 10).split('-')
      return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : iso
    },
    toggleObs(linha) {
      const i = this.obsAbertas.indexOf(linha)
      if (i > -1) this.obsAbertas.splice(i, 1)
      else this.obsAbertas.push(linha)
    },
    limparFiltros() {
      this.filtros = { vendedor: '', cliente: '', contrato: '', grupo: '', cota: '', bem: '', status: '', dataInicio: '', dataFim: '', mes: '', ano: '' }
    },
    async carregar() {
      this.carregando = true
      const r = await apiGet('vendas/listar')
      if (r.sucesso) this.vendas = r.vendas
      this.carregando = false
    },
    async carregarTabelas() {
      const r = await apiGet('tabela-comissao/listar')
      if (r.sucesso) this.tabelas = r.tabela
    },
    mascaraCpfCnpjEdicao() {
      let v = (this.edicao.cpf || '').replace(/\D/g, '')
      if (v.length <= 11) {
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      } else {
        v = v.replace(/^(\d{2})(\d)/, '$1.$2')
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')
        v = v.replace(/(\d{4})(\d)/, '$1-$2')
      }
      this.edicao.cpf = v
    },
    mascaraValorEdicao() {
      let v = (this.edicao.valor || '').replace(/\D/g, '')
      if (!v) { this.edicao.valor = ''; return }
      v = (parseInt(v) / 100).toFixed(2)
      v = v.replace('.', ',')
      v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      this.edicao.valor = 'R$ ' + v
    },
    abrirModalEditar(v) {
      const vs = (parseFloat(v.valor) || 0).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      this.edicao = {
        linha: v.linha,
        vendedor: v.vendedor,
        nomeCliente: v.cliente,
        cpf: v.cpf || '',
        numeroContrato: v.contrato,
        numeroGrupo: v.grupo,
        numeroCota: v.cota,
        valor: 'R$ ' + vs,
        bem: v.bem,
        tabelaVenda: v.tabela,
        dataAlocacao: v.dataAlocacao,
        dataVenda: v.dataVenda,
        dataVencimento: v.dataVencimento,
        lance: v.lance || '',
        numeroParticipante: v.participante ? v.participante.toString() : '',
        status: v.status || 'Ativa',
        parcelasTransferencia: v.parcelasTransferencia || '',
        novoTitular: v.novoTitular || '',
        statusCotaTransf: v.statusCotaTransf || 'Ativa',
        observacao: v.observacao || ''
      }
      this.statusEdicaoMsg = ''
      this.statusEdicaoClasse = ''
      this.modalAberto = true
    },
    async salvarEdicao() {
      if (!this.edicao.nomeCliente || !this.edicao.numeroContrato || !this.edicao.numeroGrupo || !this.edicao.bem || !this.edicao.tabelaVenda) {
        this.statusEdicaoClasse = 'erro-msg'
        this.statusEdicaoMsg = 'Preencha Cliente, Contrato, Numero Grupo, BEM e Tabela Venda.'
        return
      }
      let mesesPagos = ''
      if (this.edicao.status === 'Cancelada' || this.edicao.status === 'Estornada') {
        const resp = prompt('A cota foi cancelada/estornada. Ate qual parcela (mes) o cliente pagou?')
        mesesPagos = resp ? parseInt(resp) : 0
      }
      const body = {
        linha: this.edicao.linha,
        vendedor: this.edicao.vendedor,
        nomeCliente: this.edicao.nomeCliente,
        cpf: this.edicao.cpf,
        numeroContrato: this.edicao.numeroContrato,
        numeroGrupo: this.edicao.numeroGrupo,
        numeroCota: this.edicao.numeroCota,
        valor: valorParaNumero(this.edicao.valor),
        bem: this.edicao.bem,
        tabelaVenda: this.edicao.tabelaVenda,
        dataAlocacao: this.edicao.dataAlocacao,
        dataVenda: this.edicao.dataVenda,
        dataVencimento: this.edicao.dataVencimento,
        lance: this.edicao.lance,
        numeroParticipante: this.edicao.numeroParticipante,
        status: this.edicao.status,
        parcelasTransferencia: this.edicao.parcelasTransferencia,
        novoTitular: this.edicao.novoTitular,
        statusCotaTransf: this.edicao.statusCotaTransf,
        mesesPagos,
        observacao: this.edicao.observacao
      }
      this.statusEdicaoMsg = 'Salvando...'
      this.statusEdicaoClasse = ''
      const r = await apiPost('vendas/editar', body)
      if (r.sucesso) {
        this.modalAberto = false
        this.carregar()
      } else {
        this.statusEdicaoClasse = 'erro-msg'
        this.statusEdicaoMsg = 'Erro: ' + (r.mensagem || 'nao foi possivel salvar.')
      }
    },
    async excluir(linha, cliente) {
      if (!confirm('Excluir venda de "' + cliente + '"?')) return
      const r = await apiDelete('vendas/excluir', { linha })
      if (r.sucesso) this.carregar()
      else alert('Erro: ' + (r.mensagem || 'nao foi possivel excluir'))
    }
  }
}
</script>
